import { render, staticRenderFns } from "./mobile_contact.vue?vue&type=template&id=29309d02&scoped=true&"
import script from "./mobile_contact.vue?vue&type=script&lang=js&"
export * from "./mobile_contact.vue?vue&type=script&lang=js&"
import style0 from "./mobile_contact.vue?vue&type=style&index=0&id=29309d02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29309d02",
  null
  
)

export default component.exports